var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"highlight-row":"","columns":_vm.columns,"loading":_vm.loading,"data":_vm.data},on:{"on-current-change":_vm.handleTeamChange}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dcd9c72c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pdReferral/pdScreening/setTeam.vue
// module id = null
// module chunks = 